import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import { useDispatch } from "react-redux";
import TableRow from "@mui/material/TableRow";
import {
  Box,
  Button,
  Card,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  // DialogContentText,
  DialogTitle,
  Grid,
  // IconButton,
  Pagination,
  // TableFooter,
  // TablePagination,
  TextField,
  Tooltip,
  // useTheme,
} from "@mui/material";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import {
  CustomTableContainer,
  CustomTableHead,
  // TableContentVendorFont,
  TableHeaderFont,
} from "../../../styles/tableContent.style";
import { Send } from "@mui/icons-material";

import { DisplayText } from "../../bankDetails/components/bankAccountsContent";
import empty from "../../../assets/illo.png";
import { generateLinkForArn, getAdminAsns } from "../redux/adminAsnsSlice";
import moment from "moment";
import { Link } from "react-router-dom";
import { VendorCardLabel } from "./adminAsnsViewContent";
import { Super } from "../../vendorRegistration/components/steps/cardTrial";
import { LoadingButton } from "@mui/lab";
import { useForm } from "react-hook-form";
import { message } from "antd";

const EmptyContainer = () => (
  <Grid
    container
    spacing={0}
    direction="column"
    alignItems="center"
    justifyContent="center"
  >
    <br />
    <img src={empty} alt="empty" />

    <DisplayText> There are no ASNs to display</DisplayText>

    <br />

    <br />
  </Grid>
);

function AdminAsnsTableContent() {
  const [page, setPage] = React.useState(1);
  const [open, setOpen] = React.useState(false);
  const [item, setItem] = React.useState(null);

  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const { adminAsnsList, loading, generateLinkLoading } = useSelector(
    (state) => state.adminAsns
  );
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    formState: { errors },
    // reset,
    // control,
    // setValue,
    // resetField,
  } = useForm();
  const Asns = () => {
    dispatch(
      getAdminAsns({
        page: page,
        per_page: rowsPerPage,
        search_key: "",
      })
    );
  };

  useEffect(() => {
    Asns();
    // eslint-disable-next-line
  }, [page, rowsPerPage]);

  const emptyRows =
    page > 0
      ? Math.max(0, (1 + page) * rowsPerPage - adminAsnsList?.data?.length)
      : 0;

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  const handleClose = () => {
    setOpen(false);
    setItem(null);
  };
  const handleOpen = (id) => {
    setOpen(true);
    setItem(id);
  };
  const handleSave = (data) => {
    try {
      dispatch(
        generateLinkForArn({
          asn_id: item,
          email: data?.email,
        })
      ).then((response) => {
        if (response.payload.success) {
          setOpen(false);
          setItem(null);
        } else {
          setOpen(false);
        }
      });
    } catch (error) {
      message.error(error);
    }
  };
  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle style={{ cursor: "move", fontWeight: "Bold" }}>
          Send Link
        </DialogTitle>
        <DialogContent sx={{ paddingBottom: "0px" }}>
          <form onSubmit={handleSubmit(handleSave)}>
            <Grid container spacing={1}>
              <Grid
                item
                sx={{
                  width: "100%",
                }}
              >
                <VendorCardLabel>
                  Vendor Email<Super>*</Super>
                </VendorCardLabel>
                <TextField
                  style={{ width: "100%" }}
                  sx={{
                    input: {
                      fontSize: "14px",
                      fontFamily: "var(--font-family-reg)",
                    },
                  }}
                  placeholder="Enter Vendor Email"
                  variant="standard"
                  name="email"
                  {...register("email", {
                    required: "please enter email",
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                      message: "please enter valid email",
                    },
                  })}
                  error={Boolean(errors?.email)}
                  helperText={errors.email?.message}
                />
              </Grid>
            </Grid>
            <DialogActions style={{ alignItems: "right", marginTop: "25px" }}>
              <Button
                autoFocus
                onClick={handleClose}
                style={{ height: "40px", border: "#4059e5 solid 1px" }}
              >
                Cancel
              </Button>
              <LoadingButton
                sx={{
                  textTransform: "none",
                  background: "#4059e5",
                  width: "200px",
                  height: "40px",
                }}
                color="primary"
                variant="contained"
                type="submit"
                loading={generateLinkLoading}
                loadingPosition="start"
              >
                Send Link
              </LoadingButton>
            </DialogActions>
          </form>
        </DialogContent>
      </Dialog>
      {loading ? (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <CustomTableContainer component={Card}>
          <Table aria-label="simple table">
            <CustomTableHead>
              <TableRow>
                <TableCell>
                  <TableHeaderFont>Company Name </TableHeaderFont>
                </TableCell>
                <TableCell align="left">
                  <TableHeaderFont>ASN Number</TableHeaderFont>
                </TableCell>
                <TableCell align="left">
                  <TableHeaderFont>ASN Date</TableHeaderFont>
                </TableCell>
                <TableCell align="left">
                  <TableHeaderFont>PO Number</TableHeaderFont>
                </TableCell>
                <TableCell align="center">
                  <TableHeaderFont>Action</TableHeaderFont>
                </TableCell>
              </TableRow>
            </CustomTableHead>
            {adminAsnsList?.data?.length !== 0 ? (
              <TableBody>
                {adminAsnsList?.data?.map((row) => (
                  <TableRow
                    key={row.id}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell>
                      {row.Company?.company_name
                        ? row.Company?.company_name
                        : "Not Applicable"}
                    </TableCell>
                    <TableCell>
                      {row.asn_number ? row.asn_number : "Not Applicable"}
                    </TableCell>
                    <TableCell>
                      {row.asn_date
                        ? moment(row.asn_date).format("DD MMM YY")
                        : "Not Applicable"}{" "}
                    </TableCell>
                    <TableCell>
                      {row.Order?.order_number
                        ? row.Order?.order_number
                        : "Not Applicable"}
                    </TableCell>
                    <TableCell style={{ textAlign: "center" }}>
                      <Tooltip title="View ASN">
                        <Link
                          style={{ textDecoration: "none" }}
                          // eslint-disable-next-line
                          to={"/app/asns-list-view/" + `${row.id}`}
                        >
                          <RemoveRedEyeIcon
                            style={{
                              fill: "royalblue",
                              height: "18px",
                              width: "18px",
                            }}
                          />
                        </Link>
                      </Tooltip>
                      {row?.status === "Accepted" && (
                        <Tooltip title="Generate Link">
                          <Send
                            onClick={() => handleOpen(row?.id)}
                            style={{
                              fill: "royalblue",
                              height: "18px",
                              width: "18px",
                            }}
                          />
                        </Tooltip>
                      )}
                    </TableCell>
                  </TableRow>
                ))}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 0 * emptyRows }}></TableRow>
                )}
              </TableBody>
            ) : (
              <TableBody>
                <TableRow>
                  <TableCell colSpan={6}>
                    <CustomTableContainer>
                      <EmptyContainer />
                    </CustomTableContainer>
                  </TableCell>
                </TableRow>
              </TableBody>
            )}
          </Table>
          <Grid
            container
            className="d-flex flex-row align-items-center justify-content-between w-100 px-3 text-muted"
            sx={{ height: "8vh", borderTop: "1px solid lightgray" }}
          >
            <Grid className="d-flex align-items-center gap-2">
              <span>Rows per page: </span>
              <select
                value={rowsPerPage}
                onChange={(e) => {
                  setRowsPerPage(e.target.value);
                  setPage(1);
                }}
              >
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </select>
            </Grid>
            <Pagination
              sx={{
                width: "max-content",
              }}
              color="primary"
              variant="text"
              onChange={(_, newValue) => setPage(newValue)}
              count={adminAsnsList?.pagination?.total_page}
              page={page}
              shape="rounded"
              onRowsPerPageChange={handleChangeRowsPerPage}
              showFirstButton
              showLastButton
            />
          </Grid>
        </CustomTableContainer>
      )}
    </>
  );
}

export default AdminAsnsTableContent;
